import { FC } from 'react';

import Button from '@/components/controls/Button.tsx';

type HoleInOneClaimDetailsButtonsProps = {
  onApprove: () => void;
  onReject: () => void;
};

const HoleInOneClaimDetailsActionButtons: FC<
  HoleInOneClaimDetailsButtonsProps
> = ({ onApprove, onReject }: HoleInOneClaimDetailsButtonsProps) => {
  return (
    <div className="flex justify-end my-2">
      <Button
        buttonStyle="bg-primary-100 hover:bg-primary-200 border border-primary-100 text-white py-2 me-4 rounded-lg btn-custom-width"
        text="Approve"
        buttonType={{ type: 'button' }}
        hasImage={false}
        onClick={onApprove}
      />
      <Button
        buttonStyle="bg-red-700 hover:bg-red-800 border border-red-700 text-white py-2 rounded-lg btn-custom-width"
        text="Reject"
        buttonType={{ type: 'button' }}
        hasImage={false}
        onClick={onReject}
      />
    </div>
  );
};

export default HoleInOneClaimDetailsActionButtons;
